module.exports = __webpack_public_path__ + "static/ForceSensingShoes_Plot-8b533b4b61876315cc73fe77429355f8.png";